import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

export const DuplicateExecutionBriefFormValidationRules = yupResolver(
  yup.object({
    name: yup
      .string()
      .required("Multi Channel Brief Name is required.")
      .max(256, "Multi Channel Brief Name must be under 256 characters."),
  })
);
